module.exports = "<itpx-material-stack-presentation [state$]=\"state$\" [materialDetails$]=\"deliverables$\">\n\n</itpx-material-stack-presentation>\n\n<div itpx-modal></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/material-stack-container/material-stack-container.component.html
// module id = 949
// module chunks = 0